export default __webpack_public_path__ + "img/course-dessert.b709c3b6c909665b204252e76979e471.png";